/* eslint-disable @typescript-eslint/ban-types */
import React, { useState } from 'react'
import {
  renderHelpersText,
  renderErrorInField,
  renderUpdatedInField,
  getFieldControls,
} from '@flatsy/utils/Functions/form/Helpers'
import { FieldsType, SingleFieldProps } from '../../../../Types'
import FormTextField from '../../../../../Global/TextField'
import { renderType, renderInputsProps } from './Utils'
import { useStyle } from './Style'

const TextField = <T extends {}>({
  field,
  input,
  meta,
  values,
  justSubmitted,
}: SingleFieldProps<T>): React.ReactElement => {
  const [inputValue, setInputValue] = useState('')
  const classes = useStyle()

  /**
   * @description render label or condition label
   * @param field
   * @param values
   */
  const renderLabelInField = (field: FieldsType, values: T) => {
    if (field.icon) {
      return (
        <div className={classes.iconField}>
          <div className={classes.icon}>{field.icon}</div>
          <div>{field.label}</div>
        </div>
      )
    }
    return field.conditional ? field.conditional(values).label : field.label
  }

  /**
   * @description change field value based on the field type
   * @param val
   */
  const onChange = (val: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (field.changeEvent) {
      field.changeEvent(val.target.value)
    }
    if (field.type === 'number') {
      const newVal = parseInt(val.target.value)
      if (newVal < 0) {
        input.onChange('')
        setInputValue('')
      } else {
        input.onChange(val.target.value)
        setInputValue(val.target.value)
      }
    } else {
      input.onChange(val.target.value)
    }
  }

  const fieldControls = getFieldControls(field)

  return (
    <FormTextField
      error={!!fieldControls.error || renderErrorInField(meta)}
      updated={
        fieldControls.hasControls
          ? fieldControls.success
          : renderUpdatedInField(meta, justSubmitted)
      }
      helperText={
        fieldControls.error || renderHelpersText(field, meta.touched, meta.error, meta.submitError)
      }
      label={renderLabelInField(field, values)}
      {...input}
      fullWidth
      type={renderType(field)}
      className={field.className || undefined}
      multiline={field.type === 'textarea' ? true : undefined}
      onChange={onChange}
      InputProps={renderInputsProps(field)}
      disabled={field.disabled}
      testid={`form-field-text-${field.type}`}
      InputLabelProps={
        field.type === 'number' && inputValue && inputValue !== '' ? { shrink: true } : undefined
      }
    />
  )
}

export default TextField
